import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70973236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-num" }
const _hoisted_2 = { class: "flex-ter" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "flex-ter-cen",
  style: {"color":"#d9001b"}
}

import { t } from '@/plugins/i18n'
import { ref, watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useRtfix } from '@/store'
import AfterSalesItem from './AfterSalesItem.vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import Drawer from '@/components/common/Drawer.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { getB2bSpotCheckNumsApi } from '@/apis/inShipping'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props
const router = useRouter()



const dataList:any = ref([])
watch(() => props.visible, (newValue) => {
  if (newValue) {
    dataList.value = props.dataList
    // toggleAllSelection()
    // 查询抽检数量
    getB2bSpotCheckNumsApi([props.rowItem.deliveryTaskCode]).then((res:any) => {
      if (res.success) {
        dataList.value.forEach((item:any) => {
          const obj = res.data.find((i:any) => i.shopProductSku === item.shopProductSku)
          if (obj) {
            item.spotCheckNum = obj.spotCheckNum
          }
        })
      }
    })
  }
})
const tableConfig = {
  showSelection: true,
  rowKey: 'deliveryTaskDetailId',
  selectable: (row: any) => !row.afterSalesStatus
}

const columns: any = [
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    align: 'center',
    width: 230,
    slotName: 'shoppingInfo'
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('实际发货数量'),
    prop: 'realDeliveryNums',
    align: 'center',
    slotName: 'realDeliveryNums'
  }
]

const STableRef = ref()
const toggleAllSelection = () => {
  nextTick(() => {
    // STableRef.value && STableRef.value.toggleAllSelection()
  })
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val
}

const close = () => {
  emit('update:visible', false)
  selectionList.value = []
}

const CVisible = ref(false)
const CItem = ref()
let checkedIdx = 0
const submit = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择需要售后的商品'))
  CItem.value = { ...selectionList.value[0], platformOrderNo: props.rowItem.platformOrderNo }
  CVisible.value = true
  checkedIdx++
}

const cancel = () => {
  CVisible.value = false
  checkedIdx = 0
}
const success = () => {
  if (checkedIdx < selectionList.value.length) {
    CItem.value = { ...selectionList.value[checkedIdx++], platformOrderNo: props.rowItem.platformOrderNo }
  } else {
    CVisible.value = false
    checkedIdx = 0
    close()
    emit('refresh')
  }
}

const toStubstandardList = function (row: any) {
  router.push(
    useRtfix('SubstandardList', {
      query: {
        shopProductSku: row.shopProductSku
      }
    })
  )
}


return (_ctx: any,_cache: any) => {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Drawer, {
      visible: __props.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      onBeforeClose: close,
      onOk: submit,
      title: _unref(t)('请确认售后信息'),
      showBtn: true,
      size: "1028px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('国际发货单号')) + ": " + _toDisplayString(__props.rowItem.deliveryTaskCode), 1),
        _createElementVNode("div", null, [
          _createVNode(STable, {
            class: "productTable",
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            "table-data": dataList.value,
            columns: columns,
            tableConfig: tableConfig,
            showPagination: false,
            onSelectionChange: handleSelection,
            onDataListener: _cache[0] || (_cache[0] = ($event: any) => (toggleAllSelection()))
          }, {
            shoppingInfo: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(ShoppingPreview, {
                  image: row.productImg || '',
                  name: row.productName || '',
                  url: row.productLink || undefined
                }, null, 8, ["image", "name", "url"])
              ])
            ]),
            productSku: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.productSku), 1)
            ]),
            productPropertiesName: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/,
            '')), 1))
              }), 128))
            ]),
            shoppingStats: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(t)('已发货')) + " ", 1),
              (row.defectiveAmount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_tooltip, {
                      placement: "right",
                      effect: "light",
                      "popper-class": "tips"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createTextVNode(_toDisplayString(_unref(t)('次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。')) + " ", 1),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (toStubstandardList(row))
                          }, _toDisplayString(_unref(t)('查看转正记录>')), 9, _hoisted_5)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Warning)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(_toDisplayString(`${_unref(t)('含次品转正品')}(${row.defectiveAmount})`), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : _createCommentVNode("", true)
            ]),
            realDeliveryNums: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.realDeliveryNums) + " " + _toDisplayString(row.spotCheckNum && row.spotCheckNum>0 ?`(${_unref(t)('抽检')})` : ''), 1)
            ]),
            _: 1
          }, 8, ["table-data"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CommonDialog, {
      visible: CVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((CVisible).value = $event)),
      width: "580px",
      title:  _unref(t)('申请售后'),
      onCancel: cancel
    }, {
      default: _withCtx(() => [
        (CItem.value)
          ? (_openBlock(), _createBlock(AfterSalesItem, {
              key: 0,
              rowItem: CItem.value,
              onCancel: cancel,
              onSuccess: success,
              allIncludeFlag: __props.rowItem.allIncludeFlag
            }, null, 8, ["rowItem", "allIncludeFlag"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})